import styled from "styled-components";
import { css } from "styled-components";

type Props = {
  title?: any;
};

export const MainSection = styled.section`
  background: #fff;
  overflow: hidden;
  .container {
    margin-top: 0rem;
    padding-bottom: 6rem;
  }
  .row-reverse {
    flex-direction: row-reverse;
  }

  .color-reverse {
    background-color: #032b88;
    padding-top: 2rem;
    padding-bottom: 2rem;
    position: relative;
  }

  .low-fee-img {
    position: absolute;
    top: -65px;
    left: 45%;

    @media (max-width: 991.98px) {
      display: none;
    }
  }

  .swap-btn {
    background-color: #032b88;
    border: none;
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: capitalize;
    border-radius: 110px;
    padding: 7px 25px;
    font-family: "Inter", sans-serif !important;

    &.left-align-btn {
      /* display: block;
      margin-left: auto; */
      margin-left: 4rem;
      background-color: #fff;
      border: none;
      color: #032b88;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: capitalize;
      border-radius: 110px;
      padding: 7px 25px;
      font-family: "Inter", sans-serif !important;
    }

    &.center-align-btn {
      margin-left: 5rem;
      margin-top: 1rem;
    }

    @media (max-width: 991.98px) {
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2rem;
    }
  }
`;

export const HeaderTitle = styled.h5`
  font-size: 3.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  text-align: center;
  color: #fff;

  @media (max-width: 756px) {
    font-size: 2rem;
  }
`;

export const Title = styled.h5<Props>`
  /* color: #032b88; */
  color: #032b88;
  font-size: 2.3125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  margin-top: 4rem;

  &.title {
    color: #fff;

    @media (max-width: 990px) {
      text-align: center;
      font-size: 1.8rem;
      margin-top: 0rem;
    }
  }

  @media (max-width: 990px) {
    text-align: center;
    font-size: 1.9rem;
    margin-top: 0rem;
  }
`;

export const Text = styled.p`
  /* color: var(--a, #4d4d4d); */
  color: var(--a, #4d4d4d);
  font-size: 1.3125rem;
  font-family: "Catamaran", sans-serif;
  font-style: normal;
  font-weight: 300;
  line-height: 1.84375rem;
  text-transform: capitalize;
  margin-top: 2rem;
  width: 70%;
  white-space: pre-line;

  &.title {
    text-align: start;

    color: #fff;
    @media (max-width: 990px) {
      text-align: center;
      width: 100%;
    }
  }

  @media (max-width: 990px) {
    text-align: center;
    width: 100%;
  }
`;

export const ImgWrapper = styled.div`
  @media (max-width: 990px) {
    text-align: center;
    display: none;
  }

  img {
    /* background-color: red; */

    &.right-img {
      display: block;
      margin-left: auto;
    }

    &.margin-top {
      margin-top: 6rem;
    }

    &.reduced-margin-top {
      margin-top: 4rem;
    }
  }
`;

export const MobileWrapper = styled.div`
  text-align: center;
  @media (min-width: 990px) {
    display: none;
  }

  img {
    /* background-color: red; */
  }
`;

export const SubText = styled.div`
  border-radius: 1.9375rem;
  background: #003a96;
  margin-top: 0.5rem;
  /* width: max-content; */
  width: 28.3125rem;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 756px) {
    width: 100%;
  }

  p {
    color: var(--white, #fff);
    font-family: Catamaran;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.84375rem; /* 184.375% */
    text-transform: capitalize;
    text-align: center;
    margin-bottom: 0rem;

    @media (max-width: 756px) {
      font-size: 12px;
    }
  }
`;

export const VisaDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10rem;
  margin-left: 4rem;
  @media (max-width: 991.98px) {
    justify-content: center;
  }
`;

export const CardsSubText = styled.p`
  color: #032b88;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 29.5px; /* 295% */
  text-transform: capitalize;
  margin: 0;

  @media (max-width: 991.98px) {
    text-align: center;
  }
`;
